module.exports = __webpack_public_path__ + "assets/49b77c60a7f45a1e1808e572c839ed4e.png";